"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXSupplNote = exports.HTMLSupplNote = exports.HTMLSupplNoteCSS = void 0;
const react_1 = __importDefault(require("react"));
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
exports.HTMLSupplNoteCSS = `
.suppl-note {
    clear: both;
}
`;
exports.HTMLSupplNote = (0, html_1.wrapHTMLComponent)("HTMLSupplNote", ((props) => {
    const { el, htmlOptions, indent } = props;
    return (react_1.default.createElement("div", { className: `suppl-note indent-${indent}`, ...(0, html_1.elProps)(el, htmlOptions) },
        react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions })));
}));
exports.DOCXSupplNote = (0, component_1.wrapDOCXComponent)("DOCXSupplNote", ((props) => {
    const { el, docxOptions, indent } = props;
    return (react_1.default.createElement(tags_1.w.p, null,
        react_1.default.createElement(tags_1.w.pPr, null,
            react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
        react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: el.children, docxOptions })));
}));
//# sourceMappingURL=supplNote.js.map